import React from "react";
import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";

export const PROPERTY_TAB_ACTION_BAR_HEIGHT = 42;

const PropertyTabActionBar = ({
  leftContent = null,
  centerContent = null,
  children = null,
  showSave = true,
  saveActive = false,
  saveDisabled = false,
  saveLoading = false,
  onSave,
  saveTitle = "Upload to Cloud",
  sticky = true,
  sx = {},
}) => {
  const baseColor = saveLoading
    ? "#2563EB"
    : saveActive
    ? "#16A34A"
    : "#D1D5DB";
  const iconColor = saveLoading || saveActive ? "#FFFFFF" : "#9CA3AF";

  return (
    <Box
      sx={{
        position: sticky ? "sticky" : "static",
        top: 0,
        zIndex: 2,
        minHeight: PROPERTY_TAB_ACTION_BAR_HEIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: 1.5,
        pt: 0,
        pb: 0.5,
        backgroundColor: "#F8FAFC",
        borderBottom: "1px solid #CBD5E1",
        ...sx,
      }}
    >
      <Box
        sx={{
          minWidth: 0,
          flex: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        {leftContent}
      </Box>

      {centerContent ? (
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: { xs: "42%", md: "50%" },
            minWidth: 0,
            pointerEvents: "none",
          }}
        >
          <Box sx={{ pointerEvents: "auto", minWidth: 0 }}>{centerContent}</Box>
        </Box>
      ) : null}

      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flexShrink: 0 }}>
        {children}

        {showSave ? (
          <Tooltip title={saveLoading ? "Uploading..." : saveTitle}>
            <span>
              <Button
                size="small"
                onClick={onSave}
                disabled={saveDisabled || saveLoading}
                startIcon={
                  saveLoading ? (
                    <CircularProgress size={14} sx={{ color: "#FFFFFF" }} />
                  ) : (
                    <CloudUploadIcon sx={{ fontSize: 16 }} />
                  )
                }
                sx={{
                  minWidth: 68,
                  height: 30,
                  px: 1.1,
                  backgroundColor: baseColor,
                  color: iconColor,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "12px",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: saveLoading
                      ? "#2563EB"
                      : saveActive && !saveDisabled
                      ? "#15803D"
                      : "#D1D5DB",
                  },
                  "&:disabled": {
                    backgroundColor: saveLoading ? "#2563EB" : "#D1D5DB",
                    color: saveLoading ? "#FFFFFF" : "#9CA3AF",
                  },
                  transition: "all 0.2s ease-in-out",
                }}
              >
                Save
              </Button>
            </span>
          </Tooltip>
        ) : null}
      </Box>
    </Box>
  );
};

export default PropertyTabActionBar;
